import { Fade } from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import React from 'react';
import { ReactComponent as Loader } from './loading.svg';

const Loading = () => (
  <div>
    <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open>
      <Fade in>
        <Loader/>
      </Fade>
    </Backdrop>
  </div>
);

export default Loading;

